/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KoreaStockReturnProcessGoodsInfoVo } from './KoreaStockReturnProcessGoodsInfoVo';
import {
    KoreaStockReturnProcessGoodsInfoVoFromJSON,
    KoreaStockReturnProcessGoodsInfoVoFromJSONTyped,
    KoreaStockReturnProcessGoodsInfoVoToJSON,
    KoreaStockReturnProcessGoodsInfoVoToJSONTyped,
} from './KoreaStockReturnProcessGoodsInfoVo';

/**
 * 
 * @export
 * @interface KoreaStockProcessOrderInfoVo
 */
export interface KoreaStockProcessOrderInfoVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof KoreaStockProcessOrderInfoVo
     */
    id?: number;
    /**
     * 订单编号
     * @type {string}
     * @memberof KoreaStockProcessOrderInfoVo
     */
    orderCode?: string;
    /**
     * 仓库ID
     * @type {number}
     * @memberof KoreaStockProcessOrderInfoVo
     */
    warehouseId?: number;
    /**
     * 仓库名称
     * @type {string}
     * @memberof KoreaStockProcessOrderInfoVo
     */
    warehouseName?: string;
    /**
     * 订单状态
     * @type {number}
     * @memberof KoreaStockProcessOrderInfoVo
     */
    orderStatus?: number;
    /**
     * 订单状态名称
     * @type {string}
     * @memberof KoreaStockProcessOrderInfoVo
     */
    orderStatusName?: string;
    /**
     * 请求分组
     * @type {string}
     * @memberof KoreaStockProcessOrderInfoVo
     */
    requestGroup?: string;
    /**
     * 用户ID
     * @type {number}
     * @memberof KoreaStockProcessOrderInfoVo
     */
    userId?: number;
    /**
     * 商品列表
     * @type {Array<KoreaStockReturnProcessGoodsInfoVo>}
     * @memberof KoreaStockProcessOrderInfoVo
     */
    goodsList?: Array<KoreaStockReturnProcessGoodsInfoVo>;
}

/**
 * Check if a given object implements the KoreaStockProcessOrderInfoVo interface.
 */
export function instanceOfKoreaStockProcessOrderInfoVo(value: object): value is KoreaStockProcessOrderInfoVo {
    return true;
}

export function KoreaStockProcessOrderInfoVoFromJSON(json: any): KoreaStockProcessOrderInfoVo {
    return KoreaStockProcessOrderInfoVoFromJSONTyped(json, false);
}

export function KoreaStockProcessOrderInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaStockProcessOrderInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'orderStatusName': json['orderStatusName'] == null ? undefined : json['orderStatusName'],
        'requestGroup': json['requestGroup'] == null ? undefined : json['requestGroup'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'goodsList': json['goodsList'] == null ? undefined : ((json['goodsList'] as Array<any>).map(KoreaStockReturnProcessGoodsInfoVoFromJSON)),
    };
}

export function KoreaStockProcessOrderInfoVoToJSON(json: any): KoreaStockProcessOrderInfoVo {
    return KoreaStockProcessOrderInfoVoToJSONTyped(json, false);
}

export function KoreaStockProcessOrderInfoVoToJSONTyped(value?: KoreaStockProcessOrderInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'orderCode': value['orderCode'],
        'warehouseId': value['warehouseId'],
        'warehouseName': value['warehouseName'],
        'orderStatus': value['orderStatus'],
        'orderStatusName': value['orderStatusName'],
        'requestGroup': value['requestGroup'],
        'userId': value['userId'],
        'goodsList': value['goodsList'] == null ? undefined : ((value['goodsList'] as Array<any>).map(KoreaStockReturnProcessGoodsInfoVoToJSON)),
    };
}

